var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`loading`, _vm.isSmall ? `loading--bar--small` : `loading--bar--medium`]},[_c('div',{staticClass:"loading__bar"}),(_vm.label)?_c('div',{staticClass:"loading__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }